// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-bf257d74] .el-form-item--mini.el-form-item,\n.el-form-item--small.el-form-item[data-v-bf257d74] {\n  margin-bottom: 18px !important;\n}\n", ""]);
// Exports
module.exports = exports;
